import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { faPage } from '@fortawesome/pro-solid-svg-icons/faPage';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemPagesScannedMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	return (
		<ContentBlock
			title={t('mailItem.labels.pagesScanned')}
			content={
				mailItemData?.totalPages === 0
					? t('mailItem.labels.unopened')
					: `${mailItemData?.totalPagesScanned}/${mailItemData?.totalPages}`
			}
			iconContent={{ icon: faPage, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemPagesScannedMeta };
